
<div class="console_modal notification_modal">
  @if (options.type !== 'spinner') {
    <div class="modal-header">
      <h4 class="modal-title">{{options.title}}</h4>
      @if (options.choice !== 'multi') {
        <button type="button" class="btn-close" aria-label="Close" (click)="abort()">
          <i class="fa-solid fa-xmark" aria-hidden="true"></i>
        </button>
      }
    </div>
  }
  <div class="modal-body">
    @if (options.type !== 'spinner') {
      <div class="body_content">
        <div class="row">
          @if (isTemplate()) {
            <div class="col">
              <article class="content_message">
                <ng-template [ngTemplateOutlet]="$any(options.message)"></ng-template>
              </article>
            </div>
          } @else {
            <div class="col-2 content_type">
              @switch (options.type) {
                @case ('info') {
                  <i class="fa-solid fa-info-circle fa-4x text-primary" aria-hidden="true"></i>
                }
                @case ('danger') {
                  <i class="fa-solid fa-times-circle fa-4x text-danger" aria-hidden="true"></i>
                }
              }
              @if (options.type === 'warning' || options.choice === 'multi') {
                <i class="fa-solid fa-exclamation-triangle fa-4x text-warning" aria-hidden="true"></i>
              }
            </div>
            <div class="col">
              <article class="content_message" [innerHtml]="options.message"></article>
              @if (options.serviceError) {
                <article class="service_error">
                  <header class="error_head">
                    <button type="button" class="btn p-0" (click)="errorCollapsed = !errorCollapsed" [attr.aria-expanded]="!errorCollapsed" aria-controls="collapseExample">
                      {{(errorCollapsed ? 'Show' : 'Hide')}} error details
                      @if (!errorCollapsed) {
                        <i class="fas fa-angle-up" aria-hidden="true"></i>
                      }
                      @if (errorCollapsed) {
                        <i class="fas fa-angle-down" aria-hidden="true"></i>
                      }
                    </button>
                  </header>
                  <div class="alert alert-danger error_details" role="alert" #collapse="ngbCollapse" [(ngbCollapse)]="errorCollapsed">
                    <span class="d-block mb-1">{{options.serviceError.code}} service error</span>
                    {{options.serviceError.message}}
                  </div>
                </article>
              }
            </div>
          }
        </div>
      </div>
    }

    @if (options.type === 'spinner') {
      <article class="spinner_content">
        <h5 class="mb-2">Loading...</h5>
        <div class="loading_box">
          <ng-template [spinnerLoader]="false" size="2x"></ng-template>
        </div>
      </article>
    }
  </div>
  @if (options.type !== 'spinner' && options.choice !== 'none') {
    <div class="modal-footer" [ngClass]="{'justify-content-center': options.choice === 'single'}">
      @if (options.choice === 'multi') {
        <button type="button" class="btn brand_light" (click)="abort()">Cancel</button>
      }
      @if (options.choice !== 'support') {
        <button type="button" class="btn brand_default" (click)="confirm()">OK</button>
      }
      @if (options.choice === 'support') {
        <button type="button" class="btn brand_light" (click)="confirm()">Contact support</button>
      }
    </div>
  }
</div>
